const roundDownToNearest10 = (num) => Math.floor(num / 10) * 10;

export default roundDownToNearest10;
